export const BROWSE_CATALOGUE_NODE_TYPE = "browse_catalogue";
export const BROWSE_CATALOGUE_DEFAULT_PROMPT =
  "Please choose a category.";
export const BROWSE_CATALOGUE_MAXIMUM_PROMPT_LENGTH = 512;
export const BROWSE_CATALOGUE_PRESENTATIONS = Object.freeze([
  { value: "auto", label: "Auto" },
  { value: "buttons", label: "Buttons" },
  { value: "list", label: "List" },
]);
export const BROWSE_CATALOGUE_PATHS = Object.freeze([
  { id: "selected", label: "Selected" },
  { id: "no_categories", label: "No Categories" },
]);

const PRESENTATION_VALUES = new Set(
  BROWSE_CATALOGUE_PRESENTATIONS.map(option => option.value)
);
const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const createBrowseCatalogueConfig = () => ({
  catalogId: null,
  promptText: BROWSE_CATALOGUE_DEFAULT_PROMPT,
  presentation: "auto",
});

export const normalizeBrowseCatalogueConfig = config => ({
  catalogId: String(config?.catalogId || "").trim() || null,
  promptText:
    String(config?.promptText ?? "").trim() ||
    BROWSE_CATALOGUE_DEFAULT_PROMPT,
  presentation:
    String(config?.presentation || "").trim().toLowerCase() || "auto",
});

export const validateBrowseCatalogueConfig = config => {
  const normalized = normalizeBrowseCatalogueConfig(config);

  if (
    normalized.catalogId &&
    !GUID_PATTERN.test(normalized.catalogId)
  ) {
    return {
      isValid: false,
      reason: "invalid_catalogue",
      message: "Select a valid catalogue.",
    };
  }
  if (
    normalized.promptText.length >
    BROWSE_CATALOGUE_MAXIMUM_PROMPT_LENGTH
  ) {
    return {
      isValid: false,
      reason: "prompt_too_long",
      message: `Prompt cannot exceed ${BROWSE_CATALOGUE_MAXIMUM_PROMPT_LENGTH} characters.`,
    };
  }
  if (!PRESENTATION_VALUES.has(normalized.presentation)) {
    return {
      isValid: false,
      reason: "invalid_presentation",
      message: "Presentation must be Auto, Buttons, or List.",
    };
  }

  return { isValid: true, reason: "", message: "", normalized };
};

